import { createSlice } from '@reduxjs/toolkit';

import { ICommon } from './inspection';

const initialState: ICommon.TInitialState = {
  backButtonState: 'allow',
};

const common = createSlice({
  name: 'common',
  initialState,
  reducers: {
    toggleBackButtonState: (state, action) => {
      state.backButtonState = action.payload;
    },
  },
});

export const { toggleBackButtonState } = common.actions;

export default common.reducer;
